import React from 'react';
import { Route, RouteProps } from 'react-router-dom';

// components
import PrivateRoute from './PrivateRoute';
import Root from './Root';
import { TemplateManagement } from '../pages/apps/Templates';
import { ContactManagement } from '../pages/apps/Contacts';
// import  Payments  from '../pages/payments/Payments';
import { BroadcastManagement } from '../pages/apps/Broadcast';

// lazy load all the views

// auth
const Login = React.lazy(() => import('../pages/auth/Login'));
const Logout = React.lazy(() => import('../pages/auth/Logout'));
const Confirm = React.lazy(() => import('../pages/auth/Confirm'));
const ForgetPasswordEmail = React.lazy(() => import('../pages/auth/ForgetPasswordEmail'));
const VerifyOtp = React.lazy(() => import('../pages/auth/VerifyOtp'));
const VerifyPasswordotp = React.lazy(() => import('../pages/auth/VerifyPasswordotp'));
const ResetPassword = React.lazy(() => import('../pages/auth/ResetPassword'));
const setPasswordOtp = React.lazy(() => import('../pages/auth/SetPassword'));
const Register = React.lazy(() => import('../pages/auth/Register'));
const LockScreen = React.lazy(() => import('../pages/auth/LockScreen'));

// landing
const Landing = React.lazy(() => import('../pages/landing/'));

// dashboard
const EcommerceDashboard = React.lazy(() => import('../pages/dashboard/Ecommerce/'));
const AnalyticsDashboard = React.lazy(() => import('../pages/dashboard/Analytics/'));

// apps
const CalendarApp = React.lazy(() => import('../pages/apps/Calendar/'));
const Projects = React.lazy(() => import('../pages/apps/Projects/'));
const ProjectDetail = React.lazy(() => import('../pages/apps/Projects/Detail/'));
// - chat
const ChatApp = React.lazy(() => import('../pages/apps/Chat/'));
// - email
const Inbox = React.lazy(() => import('../pages/apps/Email/Inbox'));
const EmailDetail = React.lazy(() => import('../pages/apps/Email/Detail'));
const Payments = React.lazy(() => import('../pages/payments/SubscriptionPlans'));
const EmailCompose = React.lazy(() => import('../pages/apps/Email/Compose'));

const ReplyLibrary = React.lazy(() => import('../pages/automation/reply_library'));
const KnowledgeBaseList = React.lazy(() => import('../pages/ai_chatbot/knowledgebase'));
const ReportRegistry = React.lazy(() => import('../pages/ai_chatbot/knowledgebase/report_registry'));
const ReportUsers = React.lazy(() => import('../pages/ai_chatbot/knowledgebase/report_users'));
const KeywordAction = React.lazy(() => import('../pages/automation/keyword_action'));

// - tasks
const TaskList = React.lazy(() => import('../pages/apps/Tasks/List/'));
const Kanban = React.lazy(() => import('../pages/apps/Tasks/Board/'));
// - Templates
// const TemplateListPage = React.lazy(() => import('../pages/apps/Templates/index'));
// const Templates = React.lazy(() => import('../pages/apps/Templates/Template'));
// - file
const FileManager = React.lazy(() => import('../pages/apps/FileManager'));
// const BroadcastManagement = React.lazy(() => import('../pages/apps/Broadcast'));

// extra pages
const Error404 = React.lazy(() => import('../pages/error/Error404'));
const Error500 = React.lazy(() => import('../pages/error/Error500'));
const Unauth = React.lazy(() => import('../pages/unauth/'));
// -other
const Starter = React.lazy(() => import('../pages/other/Starter'));
// const Profile = React.lazy(() => import('../pages/other/Profile'));
const Activity = React.lazy(() => import('../pages/other/Activity'));
const Invoice = React.lazy(() => import('../pages/other/Invoice'));
const Maintenance = React.lazy(() => import('../pages/other/Maintenance'));
const Pricing = React.lazy(() => import('../pages/other/Pricing'));

// uikit
const UIElements = React.lazy(() => import('../pages/uikit'));
const Company = React.lazy(() => import('../pages/company'));
const Profile = React.lazy(() => import('../pages/profile'));
const Settings = React.lazy(() => import('../pages/settings'));
const Users = React.lazy(() => import('../pages/users'));

// widgets
const Widgets = React.lazy(() => import('../pages/widgets/'));

// icons
const Unicons = React.lazy(() => import('../pages/icons/Unicons'));
const FeatherIcons = React.lazy(() => import('../pages/icons/Feather/'));
const BootstrapIcon = React.lazy(() => import('../pages/icons/Bootstrap/'));

// forms
const BasicForms = React.lazy(() => import('../pages/forms/Basic'));
const FormAdvanced = React.lazy(() => import('../pages/forms/Advanced'));
const FormValidation = React.lazy(() => import('../pages/forms/Validation'));
const FormWizard = React.lazy(() => import('../pages/forms/Wizard'));
const FileUpload = React.lazy(() => import('../pages/forms/FileUpload'));
const Editors = React.lazy(() => import('../pages/forms/Editors'));

// charts
const Charts = React.lazy(() => import('../pages/charts/'));

// tables
const BasicTables = React.lazy(() => import('../pages/tables/Basic'));
const AdvancedTables = React.lazy(() => import('../pages/tables/Advanced'));

// maps
const GoogleMaps = React.lazy(() => import('../pages/maps/GoogleMaps'));
const VectorMaps = React.lazy(() => import('../pages/maps/VectorMaps'));

export interface RoutesProps {
    path: RouteProps['path'];
    name?: string;
    component?: RouteProps['component'];
    route?: any;
    exact?: RouteProps['exact'];
    icon?: string;
    header?: string;
    roles?: string[];
    children?: RoutesProps[];
}

// root routes
const rootRoute: RoutesProps = {
    path: '/',
    exact: true,
    component: () => <Root />,
    route: Route,
};

// dashboards
const dashboardRoutes: RoutesProps = {
    path: '/dashboard/ecommerce',
    name: 'Dashboards',
    icon: 'airplay',
    header: 'Navigation',
    children: [
        {
            path: '/dashboard/ecommerce',
            name: 'Ecommerce',
            component: EcommerceDashboard,
            route: PrivateRoute,
        },
        {
            path: '/dashboard/analytics',
            name: 'Analytics',
            component: AnalyticsDashboard,
            route: PrivateRoute,
        },
    ],
};

const calendarAppRoutes: RoutesProps = {
    path: '/apps/calendar',
    name: 'Calendar',
    route: PrivateRoute,
    roles: ['admin'],
    icon: 'calendar',
    children: [
        {
            path: '/apps/calendar',
            name: 'calender',
            component: CalendarApp,
            route: PrivateRoute,
        },
    ],
};

const chatAppRoutes: RoutesProps = {
    path: '/apps/chat',
    name: 'Chat',
    route: PrivateRoute,
    roles: ['admin','editor','user'],
    icon: 'message-square',
    children: [
        {
            path: '/apps/chat',
            name: 'chat',
            component: ChatApp,
            route: PrivateRoute,
        },
    ],
};

const emailAppRoutes: RoutesProps = {
    path: '/apps/email',
    name: 'Email',
    route: PrivateRoute,
    roles: ['admin'],
    icon: 'mail',
    children: [
        {
            path: '/apps/email/inbox',
            name: 'Inbox',
            component: Inbox,
            route: PrivateRoute,
        },
        {
            path: '/apps/email/details',
            name: 'Email Details',
            component: EmailDetail,
            route: PrivateRoute,
        },
        {
            path: '/apps/email/compose',
            name: 'Compose Email',
            component: EmailCompose,
            route: PrivateRoute,
        },
    ],
};
const automationAppRoutes: RoutesProps = {
    path: '/apps/email',
    name: 'Automation',
    route: PrivateRoute,
    roles: ['admin','editor'],
    icon: 'mail',
    children: [
        {
            path: '/automation',
            name: 'Reply Library',
            component: ReplyLibrary,
            route: PrivateRoute,
        },
        {
            path: '/keyword',
            name: 'Keyword Trigger',
            component: KeywordAction,
            route: PrivateRoute,
        },
        {
            path: '/apps/email/compose',
            name: 'Compose Email',
            component: EmailCompose,
            route: PrivateRoute,
        },
    ],
    
};

const AiAppRoutes: RoutesProps = {
    path: '/apps/email',
    name: 'Automation',
    route: PrivateRoute,
    roles: ['admin'],
    icon: 'mail',
    children: [
        {
            path: '/KnowledgeBaseList',
            name: 'Knowledge Base',
            component: KnowledgeBaseList,
            route: PrivateRoute,
        },
        {
            path: '/ReportRegistry',
            name: 'Report Registry',
            component: ReportRegistry,
            route: PrivateRoute,
        },
        {
            path: '/ReportUsers',
            name: 'Report Users',
            component: ReportUsers,
            route: PrivateRoute,
        }, 
    ],
};
const projectAppRoutes: RoutesProps = {
    path: '/apps/projects',
    name: 'Projects',
    route: PrivateRoute,
    roles: ['admin'],
    icon: 'uil-briefcase',

    children: [
        {
            path: '/apps/projects/list',
            name: 'List',
            component: Projects,
            route: PrivateRoute,
        },
        {
            path: '/apps/projects/details',
            name: 'Detail',
            component: ProjectDetail,
            route: PrivateRoute,
        },
    ],
};

const taskAppRoutes: RoutesProps = {
    path: '/apps/tasks',
    name: 'Tasks',
    route: PrivateRoute,
    roles: ['admin'],
    icon: 'clipboard',
    children: [
        {
            path: '/apps/tasks/list',
            name: 'Task List',
            component: TaskList,
            route: PrivateRoute,
        },
        {
            path: '/apps/tasks/kanban',
            name: 'Kanban',
            component: Kanban,
            route: PrivateRoute,
        },
    ],
};
const TemplatesAppRoutes: RoutesProps = {
    path: '/apps/Templates',
    name: 'Templates',
    route: PrivateRoute,
    roles: ['admin','editor'],
    icon: 'message-square',
    children: [
        {
            path: '/apps/Templates',
            name: 'Templates',
            component: TemplateManagement,
            route: PrivateRoute,
        },
    ],
};

// const fileAppRoutes: RoutesProps = {
//     path: '/apps/file-manager',
//     name: 'File Manager',
//     route: PrivateRoute,
//     roles: ['admin'],
//     icon: 'folder-plus',
//     component: FileManager,
// };
const fileAppRoutes: RoutesProps = {
    path: '/apps/file-manager',
    name: 'File Manager',
    route: PrivateRoute,
    roles: ['admin'],
    icon: 'message-square',
    children: [
        {
            path: '/apps/file-manager',
            name: 'Contacts',
            component: FileManager,
            route: PrivateRoute,
        },
    ],
};

const contactAppRoutes: RoutesProps = {
    path: '/apps/Contacts',
    name: 'Contacts',
    route: PrivateRoute,
    roles: ['admin'],
    icon: 'message-square',
    children: [
        {
            path: '/apps/Contacts',
            name: 'Contacts',
            component: ContactManagement,
            route: PrivateRoute,
        },
    ],
};
const PaymentAppRoutes: RoutesProps = {
    path: '/components/payments',
    name: 'Payments',
    route: PrivateRoute,
    roles: ['admin'],
    icon: 'message-square',
    children: [
        {
            path: '/components/payments',
            name: 'Payments',
            component: Payments,
            route: PrivateRoute,
        },
    ],
};
const broadcastAppRoutes: RoutesProps = {
    path: '/apps/Broadcast',
    name: 'Broadcast',
    route: PrivateRoute,
    roles: ['admin','editor'],
    icon: 'message-square',
    children: [
        {
            path: '/apps/Broadcast',
            name: 'Broadcast',
            component: BroadcastManagement,
            route: PrivateRoute,
        },
    ],
};

const appRoutes = [AiAppRoutes,calendarAppRoutes, chatAppRoutes, emailAppRoutes, automationAppRoutes, projectAppRoutes, taskAppRoutes, fileAppRoutes, broadcastAppRoutes, TemplatesAppRoutes, contactAppRoutes, PaymentAppRoutes];

// pages
const extrapagesRoutes: RoutesProps = {
    path: '/pages',
    name: 'Pages',
    icon: 'package',
    header: 'Custom',
    children: [
        {
            path: '/pages/starter',
            name: 'Starter',
            component: Starter,
            route: PrivateRoute,
        },
        // {
        //     path: '/pages/profile',
        //     name: 'Profile',
        //     component: Profile,
        //     route: PrivateRoute,
        // },
        {
            path: '/pages/activity',
            name: 'Activity',
            component: Activity,
            route: PrivateRoute,
        },
        {
            path: '/pages/invoice',
            name: 'Invoice',
            component: Invoice,
            route: PrivateRoute,
        },
        {
            path: '/pages/pricing',
            name: 'Pricing',
            component: Pricing,
            route: PrivateRoute,
        },
        {
            path: '/Unauth',
            name: 'Error - 500',
            component: Unauth,
            route: PrivateRoute,
        }
    ],
};

// ui
const uiRoutes: RoutesProps = {
    path: '/components',
    name: 'Components',
    icon: 'package',
    header: 'UI Elements',
    children: [
        {
            path: '/components/ui-elements',
            name: 'UIElements',
            component: UIElements,
            route: PrivateRoute,
        },
        {
            path: '/components/Company',
            name: 'Company',
            roles: ['admin'],
            component: Company,
            route: PrivateRoute,
        },
        {
            path: '/components/Users',
            name: 'Users',
            roles: ['admin'],
            component: Users,
            route: PrivateRoute,
        },
        {
            path: '/components/Profile',
            name: 'Profile',
            component: Profile,
            route: PrivateRoute,
        },
        {
            path: '/settings',
            name: 'settings',
            component: Settings,
            route: PrivateRoute,
        },
        {
            path: '/components/widgets',
            name: 'Widgets',
            component: Widgets,
            route: PrivateRoute,
        },
        {
            path: '/icons',
            name: 'Icons',
            children: [
                {
                    path: '/icons/unicons',
                    name: 'Unicons',
                    component: Unicons,
                    route: PrivateRoute,
                },
                {
                    path: '/icons/feather',
                    name: 'Feather',
                    component: FeatherIcons,
                    route: PrivateRoute,
                },
                {
                    path: '/icons/bootstrap',
                    name: 'Bootstrap Icon',
                    component: BootstrapIcon,
                    route: PrivateRoute,
                },
            ],
        },
        {
            path: '/icons',
            name: 'Company',
            children: [
                {
                    path: '/icons/unicons',
                    name: 'Unicons',
                    component: Unicons,
                    route: PrivateRoute,
                },
                {
                    path: '/icons/feather',
                    name: 'Feather',
                    component: FeatherIcons,
                    route: PrivateRoute,
                },
                {
                    path: '/icons/bootstrap',
                    name: 'Bootstrap Icon',
                    component: BootstrapIcon,
                    route: PrivateRoute,
                },
            ],
        },
        {
            path: '/forms',
            name: 'Forms',
            children: [
                {
                    path: '/forms/basic',
                    name: 'Basic Elements',
                    component: BasicForms,
                    route: PrivateRoute,
                },
                {
                    path: '/forms/advanced',
                    name: 'Form Advanced',
                    component: FormAdvanced,
                    route: PrivateRoute,
                },
                {
                    path: '/forms/validation',
                    name: 'Form Validation',
                    component: FormValidation,
                    route: PrivateRoute,
                },
                {
                    path: '/forms/wizard',
                    name: 'Form Wizard',
                    component: FormWizard,
                    route: PrivateRoute,
                },
                {
                    path: '/forms/upload',
                    name: 'File Upload',
                    component: FileUpload,
                    route: PrivateRoute,
                },
                {
                    path: '/forms/editors',
                    name: 'Editors',
                    component: Editors,
                    route: PrivateRoute,
                },
            ],
        },
        {
            path: '/components/charts',
            name: 'Charts',
            component: Charts,
            route: PrivateRoute,
        },
        {
            path: '/tables',
            name: 'Tables',
            children: [
                {
                    path: '/tables/basic',
                    name: 'Basic',
                    component: BasicTables,
                    route: PrivateRoute,
                },
                {
                    path: '/tables/advanced',
                    name: 'Advanced',
                    component: AdvancedTables,
                    route: PrivateRoute,
                },
            ],
        },
        {
            path: '/maps',
            name: 'Maps',
            children: [
                {
                    path: '/maps/googlemaps',
                    name: 'Google Maps',
                    component: GoogleMaps,
                    route: PrivateRoute,
                },
                {
                    path: '/maps/vectorMaps',
                    name: 'Google Maps',
                    component: VectorMaps,
                    route: PrivateRoute,
                },
            ],
        },
    ],
};

// auth
const authRoutes: RoutesProps[] = [
    {
        path: '/auth/login',
        name: 'Login',
        component: Login,
        route: Route,
    },
    {
        path: '/auth/register',
        name: 'Register',
        component: Register,
        route: Route,
    },
    {
        path: '/auth/confirm',
        name: 'Confirm',
        component: Confirm,
        route: Route,
    },
    {
        path: '/auth/set-email',
        name: 'Forget Password',
        component: ForgetPasswordEmail,
        route: Route,
    },
    {
        path: '/auth/set-password',
        name: 'Reset Password',
        component: ResetPassword,
        route: Route,
    },
    {
        path: '/auth/set-password',
        name: 'Reset Password',
        component: setPasswordOtp,
        route: Route,
    },
    {
        path: '/auth/set-otp',
        name: 'set Otp',
        component: VerifyOtp,
        route: Route,
    },
    {
        path: '/auth/set-password-otp',
        name: 'set Otp',
        component: VerifyPasswordotp,
        route: Route,
    },
    {
        path: '/auth/lock-screen',
        name: 'Lock Screen',
        component: LockScreen,
        route: Route,
    },
    {
        path: '/auth/logout',
        name: 'Logout',
        component: Logout,
        route: Route,
    },
];

// public routes
const otherPublicRoutes: RoutesProps[] = [
    {
        path: '/landing',
        name: 'landing',
        component: Landing,
        route: Route,
    },
    {
        path: '/maintenance',
        name: 'Maintenance',
        component: Maintenance,
        route: Route,
    },
    {
        path: '/error-404',
        name: 'Error - 404',
        component: Error404,
        route: Route,
    },
    {
        path: '/error-500',
        name: 'Error - 500',
        component: Error500,
        route: Route,
    },
];

// flatten the list of all nested routes
const flattenRoutes = (routes: RoutesProps[], parentRoles?: string[]) => {
    let flatRoutes: RoutesProps[] = [];

    routes.forEach((item: RoutesProps) => {

        const currentRoles = item.roles || parentRoles;

        const routeWithRoles = {
            ...item,
            roles: currentRoles,
        };

        flatRoutes.push(routeWithRoles);

        if (item.children) {
            flatRoutes = [
                ...flatRoutes,
                ...flattenRoutes(item.children, currentRoles),
            ];
        }
    });

    return flatRoutes;
};

// All routes
const authProtectedRoutes = [rootRoute, dashboardRoutes, ...appRoutes, extrapagesRoutes,
     uiRoutes,
    ];
const publicRoutes = [...authRoutes, ...otherPublicRoutes];

const authProtectedFlattenRoutes = flattenRoutes([...authProtectedRoutes]);
const publicProtectedFlattenRoutes = flattenRoutes([...publicRoutes]);
export { publicRoutes, authProtectedRoutes, authProtectedFlattenRoutes, publicProtectedFlattenRoutes };
